import { InjectionToken } from '@angular/core';

export const CONFIG: InjectionToken<string> = new InjectionToken<string>('WorkspaceConfig');
